import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { BATTLESHIP, OLAF } from 'HubStyleTokens/colors';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { LOCATIONS } from '../../constants/tracking/Locations';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { getClickedLinkEvent, getFaqInteractionEvent } from '../../utils/event-tracking/interactions';
import { trackEvent } from '../../utils/event-tracking/track-event';
import SkeletonWrappedFormattedMessage from '../common/i18n/SkeletonWrappedFormattedMessage';
import { TranslationsContext } from './Faq';
import { jsx as _jsx } from "react/jsx-runtime";
const QuestionContainer = styled.div.withConfig({
  displayName: "Question__QuestionContainer",
  componentId: "y2j4sq-0"
})(["margin-top:15px;background-color:", ";"], OLAF);
const QuestionOutlineBorder = styled(UIExpandableSection).withConfig({
  displayName: "Question__QuestionOutlineBorder",
  componentId: "y2j4sq-1"
})(["border-width:0 0.5px 0.5px 1px;border-style:solid;border-color:", ";"], BATTLESHIP);
const Br = styled.br.withConfig({
  displayName: "Question__Br",
  componentId: "y2j4sq-2"
})(["line-height:40px;"]);
const Bold = styled.span.withConfig({
  displayName: "Question__Bold",
  componentId: "y2j4sq-3"
})(["font-weight:bold;"]);
const Question = ({
  questionKey,
  getHref,
  onClick,
  onQuestionClick = () => {},
  getPassedInOptions = () => ({}),
  isJSX = true,
  isExternalLink = true
}) => {
  const href = getHref && getHref();
  const passedInOptions = getPassedInOptions && getPassedInOptions();
  const [isQuestionOpen, setIsQuestionOpen] = useState(false);
  const currencyCode = useSelector(activeCurrencySelector);
  const handleClickQuestion = () => {
    trackEvent(getFaqInteractionEvent({
      action: isQuestionOpen ? 'closed' : 'opened',
      value: I18n.text(`faq.${questionKey}.question`, {
        locale: 'en-us'
      }),
      questionKey
    }));
    setIsQuestionOpen(prev => !prev);
    onQuestionClick();
  };
  const handleClickLink = () => {
    if (onClick) {
      onClick();
    } else {
      trackEvent(getClickedLinkEvent({
        url: href || '',
        type: isExternalLink ? 'external' : 'internal',
        location: LOCATIONS.FAQ,
        value: questionKey
      }));
    }
  };
  const QuestionLink = ({
    children
  }) => {
    if (isExternalLink) {
      return /*#__PURE__*/_jsx(UILink, {
        external: isExternalLink,
        href: href,
        onClick: handleClickLink,
        children: children
      });
    }
    return /*#__PURE__*/_jsx(UIRouterLink, {
      to: href || '/',
      onClick: handleClickLink,
      children: children
    });
  };
  return /*#__PURE__*/_jsx(QuestionContainer, {
    children: /*#__PURE__*/_jsx(QuestionOutlineBorder, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `faq.${questionKey}.question`
      }),
      open: isQuestionOpen,
      onOpenChange: handleClickQuestion,
      children: isJSX ? /*#__PURE__*/_jsx(SkeletonWrappedFormattedMessage, {
        MessageComponent: FormattedJSXMessage,
        translationsContext: TranslationsContext,
        message: `faq.${questionKey}.answer_jsx`,
        options: Object.assign({
          currencyCode
        }, passedInOptions),
        elements: {
          Link: QuestionLink,
          FormattedNumber,
          UIList,
          UILink,
          Br,
          div: _ref => {
            let {
                children
              } = _ref,
              rest = _objectWithoutPropertiesLoose(_ref, _excluded);
            return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
              children: children
            }));
          },
          Bold
        }
      }) : /*#__PURE__*/_jsx(SkeletonWrappedFormattedMessage, {
        translationsContext: TranslationsContext,
        message: `faq.${questionKey}.answer`
      })
    })
  });
};
export default Question;